export enum ZipFormat {
  US = "US",
  US4 = "US+4",
  GB = "GB"
}